export const environment = {
  production: false,

  clientName: 'CP BUGA  - AGP',
  apiGatewayFront: 'https://adminproveedores.odinec.com.co/',
  apiGatewayBackOffice: 'https://adminproveedores.odinec.com.co/',
  apiUrl: 'https://adminproveedores.odinec.com.co/',
  urlPath: 'https://adminproveedores.odinec.com.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX
  siteKeyCaptcha: '6LcxPRkqAAAAAFy_luTywyBZz4gXFRT4mrUyhDTu',

  googleAnalyticsCode: 'UA-140785247-1',
};